import React from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import stylez from './pdf.module.css';

function Pdf({ data }) {
  const currentDate = new Date().toLocaleDateString('en-GB');
  const createPdf = () => {
    // Create a single PDF instance
    const finalDoc = new jsPDF();
  
    data.forEach((entry, index) => {
      const runName = entry.run;
      const entryDate = new Date(entry.date).toLocaleDateString('en-GB');
      const deliveryId = entry.deliveryId;
  
      // Set font styles for the header
      finalDoc.setFontSize(16);
      finalDoc.setTextColor('#FF3555');
  
      const textWidth = finalDoc.getTextWidth(runName);
      const pageWidth = finalDoc.internal.pageSize.width;
  
      // Only add a new page when there is more than one entry
      if (index > 0) {
        finalDoc.addPage('a4', 'p');
      }
  
      finalDoc.text(runName, 10, 10);
  
      // Calculate the x position for "RunSheet" to center it on the page
      const centerX = ((pageWidth+15) - finalDoc.getTextWidth('RunSheet')) / 2;
      finalDoc.setFontSize(16);
      finalDoc.setTextColor('#000000');
      finalDoc.text('RunSheet', centerX, 10);
  
      // Calculate the x position for the date to align it to the far top right
      const dateX = pageWidth - 10 - finalDoc.getTextWidth(currentDate);
      finalDoc.setFontSize(12);
      finalDoc.setTextColor('#000000');
      finalDoc.text(entryDate, dateX, 8); // Adjust the vertical position as needed
  
      // Process order details and aggregate quantities
      const quantityMap = new Map();
      entry?.order?.forEach((order) => {
        order?.products?.forEach((product) => {
          const { _id: id, productName, sku } = product.product;
          const { quantity } = product;
  
          const productIdName = `${id}-${productName}-${sku}`; // Concatenate id and productName
  
          if (quantityMap.has(productIdName)) {
            quantityMap.set(productIdName, quantityMap.get(productIdName) + quantity);
          } else {
            quantityMap.set(productIdName, quantity);
          }
        });
      });
  
      // Convert aggregated quantities back to rows
      let rows = [];
      quantityMap.forEach((quantity, productIdName) => {
        const [id, productName, sku] = productIdName.split('-'); // Split id and productName
        rows.push([sku, productName, quantity]);
      });
  
      finalDoc.autoTable({
        head: [['Product ID', 'Product Name', 'Quantity']],
        body: rows,
        startY: 20, // Adjust this value as needed
        headStyles: { fillColor: [0, 0, 0] },
        styles: {
          cellPadding: 5,
          fontSize: 10,
          fontStyle: 'bold',
        },
      });
  
      // Add run ID and page number at the bottom of each page
      finalDoc.setFontSize(10);
      finalDoc.setTextColor('#000000');
      finalDoc.text(`Run ID: ${deliveryId}`, 10, finalDoc.internal.pageSize.height - 10);
      finalDoc.text(`Page ${index + 1}`, pageWidth - 30, finalDoc.internal.pageSize.height - 10);
    });
  
    // Save the final PDF after processing all entries
    finalDoc.save(`${currentDate}-Runsheet`);
  };
  
  return (
    <div>
      <button className={stylez.pdfBtn} onClick={createPdf}>
        Download RunSheet for Selected Runs
      </button>
    </div>
  );
}

export default Pdf;
